import React, { useEffect, useState } from 'react';
import searchIcon from '../_assets/imgs/search.svg';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

function SearchBar({ search }) {
  const [searchTerm, setSearchTerm] = useState('');

  const formSchema = Yup.object().shape({
    search: Yup.string().required(),
  });
  const validationOpt = {
    resolver: yupResolver(formSchema),
  };
  const { handleSubmit } = useForm(validationOpt);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      search(searchTerm);
    }, 350);

    return () => clearTimeout(delayDebounceFn);
  }, [search, searchTerm]);

  function onFormSubmit(data) {
    setSearchTerm(data.search);
  }

  return (
    <form key={1} onSubmit={handleSubmit(onFormSubmit)} noValidate>
      <div className="search-bar input-group">
        <span className="input-group-text" id="basic-addon1">
          <img src={searchIcon} alt="" />
        </span>
        <input
          type="text"
          className="form-control"
          name="search"
          aria-describedby="basic-addon1"
          onChange={(e) => setSearchTerm(e.target.value)}
          autoComplete="off"
        />
        <button
          className="btn btn-primary"
          style={{ width: '142px', height: '46px' }}
          type="submit"
        >
          Buscar
        </button>
      </div>
    </form>
  );
}
export default SearchBar;
